import React from 'react';
import { withTheme } from 'styled-components';
import { Heading, Text } from '../../mo-gel';
import {
  StyledContainer,
  StyledHeadingContainer,
  StyledTextContainer,
  StyledButton,
  StyledButtonContents
} from './HowItWorks.styled';

import { Timeline } from '../Timeline/Timeline';
import { ReactComponent as RightArrow } from '../../images/icons/right_icon.svg';
import { withRouter } from '../../utils/withRouter';

export const HowItWorks = withTheme(
  withRouter((props: any) => {
    const { heading, text, timelineHeadings } = props.content;
    const { numberOfTimelineComponents } = props;
    const { content } = props.theme.colors;

    const goToContact = () => {
      if (props?.router && props?.router?.navigate) {
        props.router.navigate('/contact');
      } else if (props?.history && props?.history?.push) {
        props.history.push('/contact');
      }
    };

    return (
      <StyledContainer>
        <StyledTextContainer>
          <StyledHeadingContainer>
            <Heading level="h3" color={content} marginBottom="20px">
              {heading}
            </Heading>
          </StyledHeadingContainer>
          <Text as="p" display="block" color={content}>
            {text}
          </Text>
        </StyledTextContainer>
        <Timeline numberOfTimelineComponents={numberOfTimelineComponents} timelineHeadings={timelineHeadings} />
        <StyledButton primary={true} width="161px" onClick={goToContact}>
          <StyledButtonContents>
            Sign Up
            <RightArrow />
          </StyledButtonContents>
        </StyledButton>
      </StyledContainer>
    );
  })
);
